// PDOThreadsData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const pdoThreads: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Pdo Thread Lift - Elite Body Home Dubai",
            "description": "The PDO Thread Lift is a cutting-edge, non-surgical procedure designed to lift and tighten sagging skin, providing a youthful appearance without the need for invasive surgery.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/pdo-thread-lift/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Pdo Thread Lift - Elite Body Home Dubai",
                "description": "The PDO Thread Lift is a cutting-edge, non-surgical procedure designed to lift and tighten sagging skin, providing a youthful appearance without the need for invasive surgery.",
                "url": "https://elitebodyhome.com/services/pdo-thread-lift/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T13:51:36+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Pdo Thread Lift",
                "image_type": "image/jpeg",
                "video": "https://www.youtube.com/embed/krbUQbYbB-8",
                "video_duration": 139,
                "video_upload_date": "2024-05-17T10:14:01-07:00",
                "video_allow_embed": true
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Pdo Thread Lift - Elite Body Home Dubai",
                "description": "The PDO Thread Lift is a cutting-edge, non-surgical procedure designed to lift and tighten sagging skin, providing a youthful appearance without the need for invasive surgery.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg"
            },
        },
        "breadcrumbs": ["Home", "Services", "PDO Thread Lift"],
        "hero": {
            "title": "PDO Thread Lift",
            "subtitle": "Lift & Rejuvenate Naturally with PDO Threads!",
            "description": "The PDO Thread Lift is an advanced, non-surgical treatment used to lift and tighten sagging skin, restoring a youthful visage without the need for invasive surgery. This consists of the insertion of polydioxanone (PDO) threads (which dissolve) to instantaneously lift and contour the face, neck, and the rest of the body. It has become appreciated for its ability to create natural-looking results with little downtime."
        },
        "howItWorks": {
            "title": "What is a PDO Thread Lift?",
            "description": "Threads are made of polydioxanone, which has been used in surgery for many years. The sutures are inserted beneath the skin using very thin needles, and the sutures dissolve over time naturally, promoting collagen synthesis and providing better skin texture, elasticity and firmness. Unlike traditional facelifts, a PDO Thread Lift can be performed without large incisions or extensive recovery time. The threads raise droopy spots, smooth out wrinkles and provide the face with a fresher look."
        },
        "procedureSteps": {
            "heading": "PDO thread lift process Procedure for PDO Thread Lift",
            "para": "What Is The PDO Thread Lift Treatment? A PDO Thread Lift is a fast and non-invasive procedure that can be done in the office under local anesthesia. Here's a step-by-step rundown of how the process generally goes:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "An extensive consultation takes place to evaluate the areas needing treatment and to ensure the patient's desired outcomes are in line with PDO Thread Lift expectations.",
                    "icon": "fa-regular fa-calendar-check"
                },
                {
                    "title": "Anesthesia",
                    "desc": "Once you are comfortable, local anesthesia is injected to eliminate any pain throughout the surgery.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Insertion of Threads",
                    "desc": "PDO threads are introduced into the subdermal layer of the skin with the help of an ultra-fine needle in the targeted areas.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "Lifting and Contouring",
                    "desc": "The threads are strategically adjusted to hold up drooping skin and reshape the face. It can be carefully placed in the cheeks, jawline, neck, or brow area.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of PDO Thread Lift",
            "subheading": "PDO Thread Lift Benefits",
            "para": "PDO thread lift is a non-surgical method to lift and tighten the skin. The primary benefit is its ability to deliver natural, subtle results without the need for invasive surgery.",
            "items": [
                {
                    "title": "Minimally Invasive",
                    "desc": "No large incisions or stitches are needed — just a simple, minimally invasive and relatively painless procedure.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Natural Results",
                    "desc": "The threads dissolve within a few months, and the skin is firmer due to collagen stimulation.",
                    "icon": "fa-regular fa-face-grin-stars"
                },
                {
                    "title": "Immediate Improvement",
                    "desc": "You will notice some lifting and tightening right after the procedure.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Short Recovery Time",
                    "desc": "Most patients resume routine activities within several days.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Versatile Treatment Areas",
                    "desc": "PDO threads can be applied to a wide range of areas, including the face, neck, décolletage, and even the knees or abdomen depending on where you want a lift.",
                    "icon": "fa-solid fa-location-dot"
                },
                {
                    "title": "Collagen Stimulation",
                    "desc": "With PDO threads, collagen is produced while the threads dissolve, resulting in better skin texture and elasticity.",
                    "icon": "fa-solid fa-seedling"
                }
            ]
        },
        "eligibility": {
            "heading": "Am I a Good Candidate for PDO Thread Lift?",
            "subheading": "",
            "para": "The PDO Thread Lift provides a perfect solution for those wanting moderate lifting of their skin without having to go under the knife. However, it's not right for everyone.",
            "items": [
                {
                    "title": "Mild to Moderate Skin Laxity",
                    "desc": "It's best for those who have early sagging in areas such as your cheeks, jowls, neck or brow.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Good Skin Elasticity",
                    "desc": "Patient must have reasonably good skin health.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Candidates should know that this is a non-surgical procedure, and thus the results may not be as dramatic as those of a full facelift.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "No Significant Medical Conditions",
                    "desc": "PDO Thread Lifts are not recommended for those with autoimmune conditions and a history of poor wound healing.",
                    "icon": "fa-solid fa-xmark"
                }
            ]
        },
        "preparationTips": {
            "heading": "What To Do To Prepare For A PDO Thread Lift",
            "subheading": "",
            "para": "Pre-op is very important in getting good results and an uneventful recovery. Your physician will give you individualized instructions for your PDO Thread Lift.",
            "items": [
                {
                    "title": "Medications that Thin the Blood",
                    "desc": "Avoid aspirin, ibuprofen and other blood-thinning medications for at least a week before the procedure to lessen the chance of bruising.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Limit Alcohol Consumption",
                    "desc": "Do not consume alcohol for 48 hours prior to your appointment, as this can increase the risk of bruising and swelling.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Hydrate",
                    "desc": "Be sure to drink plenty of fluids in the days before the procedure.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Plan for Downtime",
                    "desc": "Since recovery is minimal, most people will experience swelling or bruising, so plan to take it easy for 24–48 hours after the treatment.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "results": {
            "heading": "Outcome & PDO Thread Lift Aftercare",
            "subheading": "",
            "para": "Most patients will notice instant improvements after a PDO Thread Lift procedure, with results continuing to develop over the next couple of months as the collagen builds. Then, you need to follow aftercare instructions to the letter to prolong the life of your results.",
            "items": [
                {
                    "title": "Before & After Results",
                    "desc": "",
                    "icon": "fa-solid fa-images"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Instructions",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Avoid Intense Facial Movement",
                    "desc": "Avoid using your facial muscles to their extreme for a week or so.",
                    "icon": "fa-solid fa-face-meh"
                },
                {
                    "title": "No Heavy Exercise",
                    "desc": "Refrain from intensive physical activity for a minimum of one week after the procedure so as not to cause an excessive reaction.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "And drink plenty of water to help your body heal naturally.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Sleep with Your Head Elevated",
                    "desc": "This reduces swelling and helps the wound to heal well.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How Long Does a PDO Thread Lift Last?",
                    "answer": "The results of a PDO Thread Lift can last anywhere from 12 to 18 months, depending on factors such as age, lifestyle, and skin type. The collagen-stimulating effects continue even after the threads dissolve."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "Most patients report minimal discomfort due to the use of local anesthesia. You may experience slight soreness or tightness post-procedure, which typically subsides within a few days."
                },
                {
                    "question": "How soon can I see the results?",
                    "answer": "You will see some immediate lifting, with final results becoming more evident over the following weeks as collagen production increases."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include minor swelling, bruising, and tenderness in the treated areas. These typically subside within a few days. Rarely, complications such as infection or thread displacement may occur."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bardtyrhnner-Image-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sfsfsfsfs-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sfsfsfsfs-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/sfsfsfsfs-3.jpg"
            ]
        },
        "product": {
            "id": 156,
            "title": "PDO Thread Lift",
            "price": 450,
            "description": "A non-surgical lifting procedure using PDO threads to rejuvenate and tighten sagging skin, providing a natural, youthful appearance."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "خيوط البوليديوكسانون لشد الوجه | Elite Body Home Dubai",
            "description": "شد الوجه بخيوط البوليديوكسانون هو إجراء غير جراحي متطور مصمم لرفع وشد الجلد المترهل، مما يمنح مظهرًا شبابيًا دون الحاجة إلى جراحة.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/pdo-thread-lift/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "خيوط البوليديوكسانون لشد الوجه | Elite Body Home Dubai",
                "description": "شد الوجه بخيوط البوليديوكسانون هو إجراء غير جراحي متطور مصمم لرفع وشد الجلد المترهل، مما يمنح مظهرًا شبابيًا دون الحاجة إلى جراحة.",
                "url": "https://elitebodyhome.com/pdo-thread-lift/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T13:51:36+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "خيوط البوليديوكسانون لشد الوجه",
                "image_type": "image/jpeg",
                "video": "https://www.youtube.com/embed/krbUQbYbB-8",
                "video_duration": 139,
                "video_upload_date": "2024-05-17T10:14:01-07:00",
                "video_allow_embed": true
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "خيوط البوليديوكسانون لشد الوجه | Elite Body Home Dubai",
                "description": "شد الوجه بخيوط البوليديوكسانون هو إجراء غير جراحي متطور مصمم لرفع وشد الجلد المترهل، مما يمنح مظهرًا شبابيًا دون الحاجة إلى جراحة.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-108.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "شد الوجه بخيوط البوليديوكسانون"],
        "hero": {
            "title": "ارفعي بشرتك وجدديها بشكل طبيعي مع خيوط البوليديوكسانون لشد الوجه",
            "subtitle": "",
            "description": "يعد شد الوجه بخيوط البوليديوكسانون (PDO) إجراء تجميلي متقدم وغير جراحي يُستخدم لرفع وشد الجلد المترهل، واستعادة المظهر الشبابي دون الحاجة إلى تدخل جراحي. يعتمد هذا العلاج على إدخال خيوط قابلة للذوبان مصنوعة من مادة البوليديوكسانون تحت الجلد، مما يساعد على رفع وشد الوجه، والرقبة، وأجزاء أخرى من الجسم بشكل فوري. يُعد من الحلول المُقدرة بفضل نتائجه الطبيعية وفترة التعافي القصيرة بعد الإجراء."
        },
        "howItWorks": {
            "title": "ما هي خيوط البوليديوكسانون لشد الوجه؟",
            "description": "تُصنع من مادة البوليديوكسانون، وهي خيوط تُستخدم في الجراحات الطبية لسنوات طويلة، يتم إدخال الخيوط تحت الجلد باستخدام إبر دقيقة للغاية، حيث تذوب تدريجياً مع الوقت، وتحفز إنتاج الكولاجين بشكل طبيعي، مما يساهم في تحسين مرونة البشرة، وملمسها، ومتناتها. وعلى عكس شد الوجه الجراحي التقليدي، لا يتطلب شد الوجه بخيوط البوليديوكسانون أي شقوق كبيرة أو فترة تعافي طويلة."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء شد الوجه بخيوط البوليديوكسانون",
            "para": "ما هو علاج شد الوجه بخيوط البوليديوكسانون؟ يُعد شد الوجه بخيوط البوليديوكسانون هو إجراء تجميلي سريع وغير جراحي يتم داخل العيادة تحت تأثير التخدير الموضعي.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يبدأ الإجراء بجلسة استشارية شاملة يقوم فيها الطبيب بتقييم المناطق التي قد تحتاج للعلاج وفهم تطلعات المريض، لضمان توافق النتائج المتوقعة مع إمكانيات خيوط البوليديوكسانون.",
                    "icon": "fa-regular fa-calendar-check"
                },
                {
                    "title": "التخدير",
                    "desc": "بعد التأكد من راحة المريض، يُستخدم مخدر موضعي لتقليل أي شعور بالألم أثناء الإجراء.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "إدخال الخيوط",
                    "desc": "تُدخل خيوط البوليديوكسانون في الطبقة تحت الجلد باستخدام إبرة دقيقة جداً في المناطق المستهدفة.",
                    "icon": "fa-solid fa-thread"
                },
                {
                    "title": "شد البشرة وإعادة تحديد الملامح",
                    "desc": "يقوم الطبيب بضبط وضعية الخيوط بعناية لرفع الجلد المترهل وإعادة تشكيل الوجه، ويمكن وضع الخيوط في مناطق متعددة مثل الخدين، أو خط الفك، أو الرقبة، أو منطقة الحاجب.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد شد الوجه بخيوط البوليديوكسانون",
            "subheading": "",
            "para": "يُعد شد الوجه بخيوط البوليديوكسانون خيارًا غير جراحي لرفع وشد الجلد، ويعتبر من الحلول التجميلية المتقدمة التي توفر نتائج طبيعية ورقيقة دون اللجوء إلى الجراحة.",
            "items": [
                {
                    "title": "إجراء غير جراحي",
                    "desc": "لا يتطلب إجراء شقوقًا كبيرة أو غرز، بل يُجرى باستخدام إبر دقيقة، مما يجعله إجراءً بسيط وغير جراحي وغير مؤلم نسبيًا.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "تذوب الخيوط تدريجيًا خلال عدة أشهر، فتظهر البشرة مشدودة أكثر نتيجة لتحفيز الخيوط على إنتاج الكولاجين الطبيعي في الجسم.",
                    "icon": "fa-regular fa-face-grin-stars"
                },
                {
                    "title": "تحسن فوري",
                    "desc": "ستلاحظ شد ورفع للبشرة فوري في المناطق المعالجة من الوجه بعد الجلسة مباشرةً.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "فترة تعافي قصيرة",
                    "desc": "يتمكن معظم المرضى من العودة إلى أنشطتهم اليومية في غضون أيام قليلة.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "يلائم استخدامه لعدة مناطق في الجسم",
                    "desc": "يمكن استخدام الخيوط في عدة مناطق مثل الوجه، أو الرقبة، أو أعلى الصدر (الديكولتيه)، كما يمكن استخدامه في الركبتين أو البطن اعتمادًا على المكان الذي تريد شد الجلد به.",
                    "icon": "fa-solid fa-location-dot"
                },
                {
                    "title": "تحفيز الكولاجين",
                    "desc": "تعزز الخيوط إنتاج الكولاجين الطبيعي أثناء ذوبانها، مما يساهم في تحسين ملمس الجلد ومرونته.",
                    "icon": "fa-solid fa-seedling"
                }
            ]
        },
        "eligibility": {
            "heading": "من المرشح المناسب لشد الوجه بخيوط البوليديوكسانون؟",
            "subheading": "",
            "para": "يُعد شد الوجه بخيوط البوليديوكسانون خيارًا مثاليًا للأشخاص الذين يرغبون في شد الجلد بشكل معتدل دون اللجوء إلى الجراحة، ولكن هذا الإجراء لا يناسب الجميع.",
            "items": [
                {
                    "title": "ترهل خفيف أو متوسط في الجلد",
                    "desc": "يُفضل استخدامه في حالات الترهل المبكرة في مناطق مثل الخدين، أو أسفل الذقن، أو الرقبة، أو الحاجبين.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "مرونة جلد جيدة",
                    "desc": "يجب أن يتمتع المريض بصحة جلدية جيدة تسمح بتحفيز الكولاجين واستجابة الجلد للشد.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "توقعات واقعية عن النتائج",
                    "desc": "ينبغي أن يدرك المرشح أن هذا إجراء غير جراحي، وبالتالي فإن النتائج ستكون طبيعية وتدريجية، وقد لا تكون بوضوح نتائج شد الوجه الجراحي.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "لا تعاني من حالات صحية خطيرة",
                    "desc": "لا يُنصح بهذا الإجراء لمن يعانون من أمراض مناعة ذاتية أو لديهم تاريخ صحي من ضعف التئام الجروح.",
                    "icon": "fa-solid fa-xmark"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يُعد التحضير المسبق عاملاً أساسياً للحصول على نتائج مثالية وتعافي سريع. سيوفر لك الطبيب تعليمات خاصة بناءً على حالتك، ولكن إليك بعض الإرشادات العامة:",
            "items": [
                {
                    "title": "تجنب الأدوية المميعة للدم",
                    "desc": "امتنع عن تناول الأسبرين أو الإيبوبروفين أو أي أدوية مميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة لتجنب ظهور كدمات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الامتناع عن الكحول",
                    "desc": "امتنع عن شرب الكحول لمدة 48 ساعة قبل الجلسة، لأنه قد يرفع من احتمالية التورم والكدمات.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "الحفاظ على ترطيب الجسم",
                    "desc": "تأكد من شرب كميات كافية من الماء في الأيام التي تسبق العلاج، للحفاظ على مرونة الجلد وتعزيز عملية التعافي.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "الاستعداد لفترة تعافي قصيرة",
                    "desc": "رغم أن فترة التعافي قصيرة، ولكن قد يظهر بعض التورم أو الكدمات، لذا يُفضل تخصيص 24 إلى 48 ساعة للراحة بعد الإجراء.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يشهد معظم المرضى تحسنًا فوريًا بعد إجراء شد الوجه بخيوط البوليديوكسانون، وتستمر النتائج في التطور تدريجيًا خلال الأشهر التالية بفضل تحفيز إنتاج الكولاجين الطبيعي في البشرة.",
            "items": [
                {
                    "title": "قبل وبعد العلاج",
                    "desc": "",
                    "icon": "fa-solid fa-images"
                }
            ]
        },
        "aftercareTips": {
            "heading": "إرشادات العناية بعد العلاج",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "تجنب حركات الوجه القوية",
                    "desc": "يُنصح بعدم استخدام عضلات الوجه بشكل مفرط لمدة أسبوع تقريبًا.",
                    "icon": "fa-solid fa-face-meh"
                },
                {
                    "title": "الامتناع عن التمارين العنيفة",
                    "desc": "تجنب ممارسة الأنشطة البدنية الكثيفة لمدة لا تقل عن أسبوع بعد الإجراء حتى لا تتسبب في رد فعل عكسي.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "الحفاظ على ترطيب الجسم",
                    "desc": "اشرب كميات كافية من الماء يوميًا لدعم عملية التعافي الطبيعية في الجسم.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "النوم والرأس مرفوع",
                    "desc": "يُفضّل النوم مع رفع الرأس، لتقليل التورم والمساعدة في التئام الأنسجة بشكل أفضل.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم نتائج شد الوجه بخيوط البوليديوكسانون؟",
                    "answer": "يمكن أن تستمر النتائج من 12 إلى 18 شهرًا، اعتمادًا على عوامل مثل العمر ونمط الحياة ونوع البشرة. يستمر تحفيز الكولاجين حتى بعد ذوبان الخيوط."
                },
                {
                    "question": "هل الإجراء مؤلم؟",
                    "answer": "يبلغ معظم المرضى عن شعور طفيف بعدم الراحة بسبب استخدام التخدير الموضعي. قد تشعر ببعض الألم أو الضيق بعد الإجراء، والذي يختفي عادةً خلال أيام قليلة."
                },
                {
                    "question": "متى يمكن رؤية النتائج؟",
                    "answer": "ستلاحظ بعض الرفع الفوري، مع ظهور النتائج النهائية بشكل أكثر وضوحًا خلال الأسابيع التالية مع زيادة إنتاج الكولاجين."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورمًا طفيفًا وكدمات وألمًا في المناطق المعالجة. تختفي هذه الأعراض عادةً خلال أيام قليلة. نادرًا ما تحدث مضاعفات مثل العدوى أو تحرك الخيوط."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
};
